var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66685 4.99984V4.33317C6.66685 2.85817 6.66685 1.6665 9.33351 1.6665H10.6668C13.3335 1.6665 13.3335 2.85817 13.3335 4.33317V4.99984M6.66685 18.3332H13.3335C16.6835 18.3332 17.2835 16.9915 17.4585 15.3582L18.0835 8.6915C18.3085 6.65817 17.7252 4.99984 14.1668 4.99984H5.83351C2.27518 4.99984 1.69185 6.65817 1.91685 8.6915L2.54185 15.3582C2.71685 16.9915 3.31685 18.3332 6.66685 18.3332Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6664 11.6832V10.8332C11.6664 9.99984 11.6664 9.99984 10.8331 9.99984H9.16644C8.33311 9.99984 8.33311 9.99984 8.33311 10.8332V11.6915M11.6664 11.6832C11.6664 12.5915 11.6581 13.3332 9.99977 13.3332C8.34977 13.3332 8.33311 12.5998 8.33311 11.6915M11.6664 11.6832C13.9699 11.3964 16.1632 10.5306 18.0414 9.1665M8.33311 11.6915C6.17477 11.4498 4.05811 10.6748 2.18311 9.3915",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.045a4cb6039571272f2f0c6a1860a4b8.svg";
export { ForwardRef as ReactComponent };